module.exports = __webpack_public_path__ + "static/media/权益五@2x.6f1ef482.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_121/img/权益五@2x.png
// module id = 1140
// module chunks = 0